export class UIRendererService {
  static renderLoadingState(): string {
    return `
      <div class="survey-container enhanced-loading" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 60vh; background: transparent; box-shadow: none; border-radius: 0;">
        <img src="/billy_verify.png" alt="Loading" width="180" height="180" style="margin-bottom: 24px; animation: levitate 1.8s ease-in-out infinite alternate;" />
        <h2 style="font-size: 2rem; margin-bottom: 12px; color: #334155;">Loading Survey</h2>
        <p style="font-size: 1.2rem; color: #333; margin-bottom: 24px; text-align: center;">Please wait while we prepare your survey...</p>
      </div>
      <style>
        .enhanced-loading {
          background: transparent !important;
          box-shadow: none !important;
          border-radius: 0 !important;
        }
        @keyframes levitate {
          0% { transform: translateY(0); }
          100% { transform: translateY(-18px); }
        }
      </style>
    `;
  }

  static renderErrorState(message: string, status?: number): string {
    const msg = (message || '').toLowerCase();
    let img = "/billy_raise_hand.png";
    let title = "Survey Error";
    let friendlyMsg = message || "An error occurred. Please try again.";
    let titleStyle = 'font-size: 2rem; margin-bottom: 12px; color: #334155; text-align: center;';

    // Robust status/message matching - customize title/image but preserve API message
    if ((status === 404 && /survey not found/.test(msg)) || /survey not found/.test(msg)) {
      img = "/billy_glasses.png";
      title = "Survey Not Found";
    } else if ((status === 403 && /user not found/.test(msg)) || /user not found/.test(msg)) {
      img = "/billy_catch_hat.png";
      title = "User Not Found";
    } else if ((status === 409 && /already completed/.test(msg)) || /already completed/.test(msg)) {
      img = "/billy_lock_check.png";
      title = "Survey Already Completed";
      titleStyle = 'font-size: 2rem; margin-bottom: 12px; color: #22c55e; text-align: center;';
    } else if (/maximum.*responses/.test(msg) || /max.*responses/.test(msg)) {
      img = "/billy_lock_check.png";
      title = "Survey Closed";
    } else if ((status === 403 && /survey not available/.test(msg)) || /survey not available/.test(msg)) {
      img = "/billy_catch_hat.png";
      title = "Survey Not Available";
    } else if ((status === 410 && /survey expired/.test(msg)) || /survey expired/.test(msg)) {
      img = "/billy_catch_hat.png";
      title = "Survey Expired";
    } else if (status === 400) {
      img = "/billy_raise_hand.png";
      title = "Survey Error";
    } else if (status === 500) {
      img = "/billy_raise_hand.png";
      title = "Connection Error";
    }
    // friendlyMsg always uses the original API message
    return `
      <div class="survey-container enhanced-error" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 60vh; background: transparent; box-shadow: none; border-radius: 0;">
        <img src="${img}" alt="${title}" width="180" height="180" style="margin-bottom: 24px;" />
        <h1 style="color: ${titleStyle.includes('#22c55e') ? '#22c55e' : '#334155'}; margin-bottom: 12px;">${title}</h1>
        <p style="font-size: 1.2rem; color: #333; margin-bottom: 24px; text-align: center;">${friendlyMsg}</p>
        <div class="error-actions">
          <button onclick="window.location.reload()" class="retry-btn">Refresh Page</button>
        </div>
      </div>
      <style>
        .enhanced-error {
          background: transparent !important;
          box-shadow: none !important;
          border-radius: 0 !important;
          animation: fadeInError 0.7s cubic-bezier(.68,-0.55,.27,1.55);
        }
        @keyframes fadeInError {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      </style>
    `;
  }

  static renderSubmissionError(message: string): string {
    return `
      <div class="survey-container enhanced-error" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 60vh; background: transparent; box-shadow: none; border-radius: 0;">
        <img src="/billy_raise_hand.png" alt="Submission Failed" width="180" height="180" style="margin-bottom: 24px;" />
        <h1 style="color: #334155; margin-bottom: 12px;">Submission Failed</h1>
        <p class="error-message" style="font-size: 1.2rem; color: #333; margin-bottom: 24px; text-align: center;">${message}</p>
        <div class="error-actions">
          <button onclick="history.back()" class="retry-btn secondary">Go Back</button>
          <button onclick="window.location.reload()" class="retry-btn">Try Again</button>
        </div>
      </div>
      <style>
        .enhanced-error {
          background: transparent !important;
          box-shadow: none !important;
          border-radius: 0 !important;
          animation: fadeInError 0.7s cubic-bezier(.68,-0.55,.27,1.55);
        }
        @keyframes fadeInError {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      </style>
    `;
  }
} 